import { defineMessages } from 'react-intl';

export default defineMessages({
    searchClaimPageTitle: {
        id: 'ax_claims.views.select.title',
        defaultMessage: 'Search and select claim'
    },
    claimNumberSeacrhInput: {
        id: 'ax_servicerequest.views.new-service-request.search-placeholder',
        defaultMessage: 'Search # claim'
    },
    pulicyNumber: {
        id: 'ax_servicerequest.views.new-service-request.policy-number',
        defaultMessage: 'Policy number'
    },
    mainConcatc: {
        id: 'ax_servicerequest.views.new-service-request.main-contact',
        defaultMessage: 'Main contact'
    },
    lossDate: {
        id: 'ax_servicerequest.views.new-service-request.loss-date',
        defaultMessage: 'Loss date'
    },
    lossLocation: {
        id: 'ax_servicerequest.views.new-service-request.loss-location',
        defaultMessage: 'Loss location'
    },
    error: {
        id: 'ax_servicerequest.views.new-service-request.error',
        defaultMessage: 'No claim number'
    },
    errorMessage: {
        id: 'ax_servicerequest.views.new-service-request.errorMessage',
        defaultMessage: 'Please enter a claim number for the search!'
    },
    noResults: {
        id: 'ax_servicerequest.views.new-service-request.noResults',
        defaultMessage: 'No results'
    },
    noResultsMessage: {
        id: 'ax_servicerequest.views.new-service-request.noResultsMessage',
        defaultMessage: 'No results were found using the claim number provided!'
    },
});
